import { elements } from '../../../dom';

type GenerateButtonState = {
  hasAudioFile: boolean;
  hasAudioMeta: boolean;
  hasGeneratedOutput: boolean;
  isBusy: boolean;
  isReadingAudio: boolean;
};

export function createExportControls(onGenerate: () => void) {
  elements.generateButton.addEventListener('click', onGenerate);

  return {
    resetDownload() {
      elements.downloadLink.removeAttribute('href');
      elements.downloadLink.classList.remove('is-ready');
      elements.downloadLink.classList.add('disabled');
      elements.downloadLink.hidden = true;
    },
    showDownload(url: string, filename: string) {
      elements.downloadLink.href = url;
      elements.downloadLink.download = filename;
      elements.downloadLink.classList.remove('disabled');
      elements.downloadLink.hidden = false;
      requestAnimationFrame(() => {
        elements.downloadLink.classList.add('is-ready');
      });
    },
    updateGenerateButton({ hasAudioFile, hasAudioMeta, hasGeneratedOutput, isBusy, isReadingAudio }: GenerateButtonState) {
      const isLoading = isBusy || isReadingAudio;
      elements.generateButton.disabled = isLoading || hasGeneratedOutput || !hasAudioFile || !hasAudioMeta;
      elements.generateButton.querySelector('span')!.textContent = isBusy
        ? 'Rendering'
        : isReadingAudio
          ? 'Reading file'
          : hasGeneratedOutput
            ? 'Generated'
            : 'Generate Video';
      elements.generateButton.classList.toggle('busy', isLoading);
      if (isLoading) {
        elements.generateButton.setAttribute('aria-busy', 'true');
      } else {
        elements.generateButton.removeAttribute('aria-busy');
      }
    },
  };
}
